// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications[data-v-9c0fc14c] {\n  -ms-overflow-style: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  overflow: scroll;\n  scrollbar-width: none;\n}\n.notifications[data-v-9c0fc14c]::-webkit-scrollbar {\n  display: none;\n}\n.notifications p[data-v-9c0fc14c] {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
